import React, { useState, useEffect } from "react";
import { AxiosResponse } from "axios";
import Backdrop from "components/Backdrop";
import PayslipsTable from "features/payslips/PayslipsTable";
import { PayslipType, PaginatedResponse } from "types/payroll-types";
import { fetchMyPayslipsAPI, fetchMyPayslipsWithSearchAPI, fetchMyPayslipsPageAPI } from "api/apiHelper";

const MyPayslips = () => {
  const [payslips, setPayslips] = useState<PayslipType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [paginationData, setPaginationData] = useState<PaginatedResponse<PayslipType> | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [pageSize, setPageSize] = useState<number>(10);
  const [error, setError] = useState<string>("");

  const getMyPayslips = async () => {
    setIsLoading(true);
    try {
      const response: AxiosResponse<PaginatedResponse<PayslipType>> = 
        await fetchMyPayslipsWithSearchAPI(pageSize, searchTerm);
      console.log("My Payslips: ", response.data);
      setPaginationData(response.data);
      setPayslips(response.data.results);
      setCurrentPage(1);
      setIsLoading(false);
      setError("");
    } catch (error: any) {
      console.log(error);
      setError(error.message);
      setIsLoading(false);
    }
  };

  const getMyPasylipsPage = async (pageUrl: string, action: string) => {
    setIsLoading(true);
    try {
      const response: AxiosResponse<PaginatedResponse<PayslipType>> = 
        await fetchMyPayslipsPageAPI(pageUrl);
      setPaginationData(response.data);
      setPayslips(response.data.results);
      setCurrentPage((prev) => (action === "next" ? prev + 1 : prev - 1));
      setIsLoading(false);
    } catch (error: any) {
      console.log(error);
      setError(error.message);
      setIsLoading(false);
    }
  };

  const handleSearch = async () => {
    getMyPayslips();
  };

  const handlePageSizeChange = (newSize: number) => {
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    getMyPayslips();
  }, [pageSize]);

  return (
    <div className="container mt-5">
      {isLoading ? (
        <Backdrop show={isLoading} />
      ) : (
        <div>
          {error && <p className="text-red-500">{error}</p>}

          <div className="mb-4 flex gap-2">
            <input
              type="text"
              placeholder="Search by Name, Status, or Period..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              onClick={handleSearch}
              className="px-6 py-2 bg-brand-500 text-white font-bold rounded-lg hover:bg-brand-600 dark:bg-brand-400 dark:hover:bg-brand-500"
            >
              Search
            </button>
          </div>

          {payslips && (
            <PayslipsTable 
              tableData={payslips} 
              tableName="Payslips" 
              ownPayslips={true}
              paginationData={paginationData}
              currentPage={currentPage}
              pageSize={pageSize}
              getMyPayslipsPage={getMyPasylipsPage}
              onPageSizeChange={handlePageSizeChange}
            />
          )}
        </div>
      )}
    </div>
  );
};
export default MyPayslips;